module.exports = __webpack_public_path__ + "static/img/img_3.6e657ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_atp/img_3.png
// module id = qzIq
// module chunks = 0